import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const userApi = createApi({
    reducerPath: 'userApi',
    baseQuery: fetchBaseQuery({

        baseUrl: process.env.REACT_APP_API_URL,

        prepareHeaders: (headers) => {
            const token = localStorage.getItem('token');
            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),

    tagTypes: ['user'],

    endpoints: (builder) => ({

        createUser: builder.mutation({
            query: (userData) => {
                const formData = new FormData();
                Object.entries(userData).forEach(([key, value]) => {
                    formData.append(key, value);
                });

                return {
                    url: '/create-user/',
                    method: 'POST',
                    body: formData,
                };
            },
            invalidatesTags: ['User'],
        }),


        deleteUser: builder.mutation({
            query: (email) => {
                const formData = new FormData();
                formData.append('email', email);

                return {
                    url: '/delete-user/',
                    method: 'DELETE', // <-- use POST instead of DELETE
                    body: formData,
                };
            },
            invalidatesTags: ['User'],
        }),


        getAllUsers: builder.query({
            query: () => `/users/`,
            providesTags: ['User'],
        }),

    }),
});

export const {
    useCreateUserMutation,
    useDeleteUserMutation,
    useGetAllUsersQuery,
} = userApi;
